<style lang="less" scoped>
</style>
<template>
    <base-page :title="$t('l.server_exception')" icon="ios-bug">
        <Row  slot="extra" type="flex" justify="end">
            <Col>
                <Button type="primary" @click="loadData(page.current)">{{$t('l.fresh')}}</Button>
            </Col>
            <Col class="margin-left-5">
                <res-view :keyName="'fun_exception_delete'">
                    <Button type="primary" @click="onDelete">{{$t('l.delete')}}</Button>
                </res-view>
            </Col>
            <Col class="margin-left-5 margin-right-5">
                <res-view :keyName="'fun_exception_empty'">
                    <Button type="error" @click="onEmpty">{{$t('l.clear')}}</Button>
                </res-view>
            </Col>
        </Row>
        <template>
            <Row class="margin-top-10">
                <Table stripe border
                       ref="table"
                       :columns="getColumns"
                       :data="data"
                       :loading="loading"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="center">
                <Col>
                    <Page :current="page.current"
                          :page-size="page.size"
                          :total="page.total"
                          show-elevator
                          @on-change="loadData($event)"
                          size="small">
                    </Page>
                </Col>
            </Row>
        </template>
    </base-page>
</template>
<script>
    import expandRow from './component/exception-expand';
    import util from '@/libs/util';
    import ResView from '../my-components/res-view';
    import BasePage from "../my-components/base-page";

    export default {
        components: {BasePage, ResView, expandRow},
        data () {
            return {
                loading: false,
                page: {
                    current: 1,
                    size: 10,
                    total: 0,
                    sortKey: 'id',
                    sortMethod: 'desc'
                },
                data: []
            };
        },
        methods: {
            loadData (page) {
                this.loading = true;
                util.ajax.get('/exception/getlist', {
                    params: {
                        page: page || 1,
                        size: this.page.size,
                        orderKey: this.page.sortKey,
                        orderMethod: this.page.sortMethod,
                        search: this.search
                    }
                }).then((res) => {
                    this.loading = false;
                    this.page.current = res.current;
                    this.page.total = res.total;
                    this.data = res.list;
                });
            },
            onDelete () { // 删除
                let ids = [];
                if (this.$refs.table.getSelection().length > 0) {
                    for (var row of this.$refs.table.getSelection()) {
                        ids = ids.concat(row.id);
                    }
                    util.ajax.get('/exception/delete?ids='+ids).then((res) => {
                        this.loadData(1);
                    });
                } else {
                    this.$Message.warning('请选择要删除的记录');
                }
            },
            onEmpty () { // 清空
                this.$Modal.confirm({
                    title:'警告',
                    content:'确定删除所有异常记录？',
                    onOk:()=>{
                        util.ajax.post('/exception/empty').then((res) => {
                            this.loadData(1);
                        });
                    }
                })
            },
        },
        mounted () {
            this.loadData();
        },
        computed:{
            getColumns(){
                return [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 60,
                    },
                    {
                        type: 'expand',
                        title: this.$t('l.stack_track'),
                        width: 100,
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    title:'Stacktrace',
                                    row: params.row
                                }
                            });
                        }
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        width: 100
                    },
                    {
                        title: 'URI',
                        key: 'path'
                    },
                    {
                        title: this.$t('l.exception'),
                        key: 'message'
                    },
                    {
                        title: this.$t('l.para'),
                        key: 'j_param',
                    },
                    {
                        title: this.$t('l.manager') + " ID",
                        key: 'admin_id',
                        width: 100
                    },
                    {
                        title: this.$t('l.occur_time'),
                        key: 'insert_time',
                        width: 180
                    }
                ]
            }
        }
    };
</script>
